import { useAppRegion } from '@/hooks/dataHelpers';
import { useMemo } from 'react';

export type RealtimeDbProviderName = 'firestore' | 'supabase';

export const useRealtimeDbProviderName = (
  dataProviderName?: RealtimeDbProviderName | string | null
): RealtimeDbProviderName | string => {
  const appRegion = useAppRegion();

  return useMemo<RealtimeDbProviderName | string>(() => {
    if (dataProviderName) {
      return dataProviderName;
    }

    return appRegion === 'china' ? 'supabase' : 'firestore';
  }, [appRegion, dataProviderName]);
};
